// dashbaord
import Dashboard from "../Dashboard/Screen";


import ContactIndex from "../Application/SystemCore/Contact/Screen";
import MultimediaIndex from "../Application/SystemCore/Multimedia/Screen";

import UserIndex from "../Application/Privilege/User/Screen";
import UserShow from "../Application/Privilege/User/Screen/UserShow";
import RoleIndex from "../Application/Privilege/Role/Screen";
import RoleShow from "../Application/Privilege/Role/Screen/RoleShow";
import PermissionShow from "../Application/Privilege/Permission/Screen/PermissoinShow";
import PermissionIndex from "../Application/Privilege/Permission/Screen";
import Settings from "../Application/SystemCore/Setting/Setting/Screen";
import BoardIndex from "../Application/Application/Board/Board/Screen";
import CollectorIndex from "../Application/Application/Collector/Collector/Screen";
import ParticipantIndex from "../Application/Application/Participant/Participant/Screen";
import ExtraFieldIndex from "../Application/SystemCore/ExtraField/ExtraField/Screen";
import ConfigurationShow from "../Application/SystemCore/Setting/Setting/Screen/ConfigurationShow";
import {getApplicationRoute, getPrivilegeRoute, getSystemCoreRoute} from "./RouteIndex";
import BoardShow from "../Application/Application/Board/Board/Screen/BoardShow";
import CollectorShow from "../Application/Application/Collector/Collector/Screen/CollectorShow";
import ParticipantShow from "../Application/Application/Participant/Participant/Screen/ParticipantShow";
import WalletIndex from "../Application/Application/Wallet/Wallet/Screen";
import WalletShow from "../Application/Application/Wallet/Wallet/Screen/WalletShow";
import WalletTransactionIndex from "../Application/Application/Wallet/WalletTransaction/Screen";

export const routes = [
    //System Core
    //Common
    {path: `${process.env.PUBLIC_URL}`, Component: <Dashboard/>},
    {path: `${process.env.PUBLIC_URL}/dashboard`, Component: <Dashboard/>},
    //Privilege
    {path: getPrivilegeRoute('user', true), Component: <UserIndex/>},
    {path: `${getPrivilegeRoute('user', true)}/:user`, Component: <UserShow/>},
    {path: getPrivilegeRoute('role', true), Component: <RoleIndex/>},
    {path: `${getPrivilegeRoute('role', true)}/:role`, Component: <RoleShow/>},
    {path: getPrivilegeRoute('permission', true), Component: <PermissionIndex/>},
    {path: `${getPrivilegeRoute('permission', true)}/:permission`, Component: <PermissionShow/>},
    // Settings
    {path: getSystemCoreRoute('setting', true), Component: <Settings/>},
    {path: getSystemCoreRoute('configuration', true), Component: <ConfigurationShow/>},

    {path: getSystemCoreRoute('extra-field', true), Component: <ExtraFieldIndex/>},
    {path: `${getSystemCoreRoute('setting', true)}/?:setting`, Component: <Settings/>},
    {path: getApplicationRoute('board', true), Component: <BoardIndex/>},
    {path: `${getApplicationRoute('board', true)}/:board`, Component: <BoardShow/>},
    {path: getApplicationRoute('collector', true), Component: <CollectorIndex/>},
    {path: `${getApplicationRoute('collector', true)}/:collector`, Component: <CollectorShow/>},
    {path: getApplicationRoute('participant', true), Component: <ParticipantIndex/>},
    {path: `${getApplicationRoute('participant', true)}/:participant`, Component: <ParticipantShow/>},
    {path: getApplicationRoute('wallet', true), Component: <WalletIndex/>},
    {path: `${getApplicationRoute('wallet', true)}/:wallet`, Component: <WalletShow/>},
    {path: getApplicationRoute('wallet-transaction', true), Component: <WalletTransactionIndex/>},

    {path: getSystemCoreRoute('contact', true), Component: <ContactIndex/>},
    {path: getSystemCoreRoute('multimedia', true), Component: <MultimediaIndex/>},
];
